import { Component, OnInit } from '@angular/core';
import { HeaderService } from '../../_services/header.service';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/_services';
import { ActivationRequest } from 'src/app/_models';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-validate',
  templateUrl: './user-validate.component.html',
  styleUrls: ['./user-validate.component.css']
})

export class UserValidateComponent implements OnInit {

  public validated : boolean = false;

  constructor(
    private header  : HeaderService,
    private route : ActivatedRoute,
    private users: UserService,
    private toastr : ToastrService,
    private translate : TranslateService
  ) { 
    this.header.setHeader(false,false,false,false);
  }

  ngOnInit() {

    let params: any = this.route.snapshot.params;

    this.users.activate(new ActivationRequest(params)).subscribe(
      result =>{
        this.validated = true;
      },
      error =>{
        this.validated = false;
      }
    );

    // TEST
    // this.validated = true;

  }

  validateUser(){
    let params: any = this.route.snapshot.params;

    this.users.activate(new ActivationRequest(params)).subscribe(
      result =>{
        this.validated = true;
      },
      error =>{
        this.validated = false;
      }
    );
  }
}
